import { motion } from "framer-motion";

/* Headline that reveals word by word: blur → sharp, rising into place. */
export const BlurText = ({ text, className, testId }) => (
  <h1 data-testid={testId} className={`flex flex-wrap justify-center gap-y-[0.1em] ${className}`}>
    {text.split(" ").map((word, i) => (
      <motion.span
        key={`${word}-${i}`}
        className="inline-block mr-[0.28em]"
        initial={{ filter: "blur(10px)", opacity: 0, y: 50 }}
        animate={{ filter: ["blur(10px)", "blur(5px)", "blur(0px)"], opacity: [0, 0.5, 1], y: [50, -5, 0] }}
        transition={{ duration: 0.7, times: [0, 0.5, 1], ease: "easeOut", delay: 0.5 + i * 0.1 }}
      >
        {word}
      </motion.span>
    ))}
  </h1>
);
